import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { mapFramesizeFacetToLabelKeys } from '@grandvisionhq/utils';
import { TileLayout } from '../../TileLayout/TileLayout.js';
import { FacetLink } from '../components/FacetLink.js';

const FrameSizeFacet = ({ item , isActive , className , onPick , productType ,  })=>{
    const { getLabel  } = useIntl();
    const { title , subtitle  } = React.useMemo(()=>{
        const keys = mapFramesizeFacetToLabelKeys(item.facetTerm);
        if (!keys) return {
            title: `${item.facetTerm}`
        };
        return {
            title: getLabel(keys.title),
            subtitle: getLabel(keys.subtitle)
        };
    }, [
        getLabel,
        item.facetTerm
    ]);
    const accessibleName = subtitle ? `${title}: ${subtitle}` : title;
    return /*#__PURE__*/ React.createElement(FacetLink, {
        item: item,
        isActive: isActive,
        onPick: onPick,
        className: className,
        productType: productType,
        accessibleName: accessibleName
    }, /*#__PURE__*/ React.createElement(TileLayout, {
        title: title,
        subtitle: subtitle
    }));
};

export { FrameSizeFacet };
//# sourceMappingURL=FrameSizeFacet.js.map
